import { createStore } from 'satcheljs';
export var getConversationInformationForPreviewStore = createStore('ConversationInformationForPreviewnStore', {
    conversationId: {
        Id: '',
        mailboxInfo: null,
    },
    conversationSubject: '',
});
//# sourceMappingURL=ConversationInformationForPreviewStore.js.map